import { createFileRoute, redirect } from '@tanstack/react-router';
import { PROTECTED, ADMINISTRATION } from '@/lib/constants/routes';

// Redirect compat: i finanziamenti vivono ora sotto `/administration/$id` tab `debts`.
export const Route = createFileRoute(
  '/protected/_layout/documents/_layout/debts/$id'
)({
  beforeLoad: ({ search, params }) => {
    throw redirect({
      to: `${PROTECTED}${ADMINISTRATION}/${params.id}`,
      search: { ...search, subTab: 'debts' },
    } as never);
  },
  component: () => null,
});
